/* eslint-disable*/

import { Typography, Box } from '@material-ui/core'; // eslint-disable-line
import { useSelector } from 'react-redux';
import { currentchannel } from 'feactures/channel/channelSlice';
import {
  selectAmazonCategoryShareGraph,
  selectRakutenCategoryShareGraph,
  selectYahooCategoryShareGraph
} from 'feactures/brand/categoryBrandShareSlice';
import { useLocation } from 'react-router';
import CategorySharegraph from 'components/molecules/dashboard/CategorySharegraph';

const BrandItemShare = () => {
  // 実際のデータはuseEffectで取得しreduxへ
  const categoryShareAmazonGraphData = useSelector(
    selectAmazonCategoryShareGraph
  );
  const categoryShareRakutenGraphData = useSelector(
    selectRakutenCategoryShareGraph
  );
  const categoryShareYahooGraphData = useSelector(
    selectYahooCategoryShareGraph
  );
  const channel = useSelector(currentchannel);
  const location = useLocation();
  const path = location.pathname;

  let categoryShareGraphData = {
    sales: [],
    percentage: [],
    label: [],
    cumulative_percentages: []
  };

  if (channel == 1) {
    categoryShareGraphData = categoryShareAmazonGraphData.graphdata;
  } else if (channel == 2) {
    categoryShareGraphData = categoryShareRakutenGraphData.graphdata;
  } else if (channel == 3) {
    categoryShareGraphData = categoryShareYahooGraphData.graphdata;
  }

  const sales = categoryShareGraphData.sales;
  const count = sales.filter((item) => item >= 1).length;
  const hasOneOrMore = count >= 1;

  // brandcomparison のみ枠内に見出しを残す（分析画面は親でタイトル表示）
  const showInlineTitle = path === '/app/brandcomparison';

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        minHeight: 0,
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      {showInlineTitle ? (
        <Typography fontSize="14px" fontWeight="bold" sx={{ mb: 1 }}>
          競合社店舗：商品別売上シェア
        </Typography>
      ) : null}
      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        {hasOneOrMore ? (
          <CategorySharegraph
            graphdata={categoryShareGraphData}
            labelLayout="legend"
          />
        ) : (
          <Typography fontSize={15}>表示できるデータがありません</Typography>
        )}
      </Box>
    </Box>
  );
};

export default BrandItemShare;
